import StatusMessages from "../helpers/statusmessage.js";

const MESSAGES = {
    error: "There was an error with Google reCAPTCHA. Please refresh and try again."
};

export default class RecaptchaForm {
    constructor() {
        this.recaptchaKey = document.getElementById("RecaptchaSiteKey")?.value || '';
        this.recaptchaName = document.getElementById("RecaptchaActionName")?.value || '';
        this.form = null;
    }

    // Initializes the reCAPTCHA instance
    init(form) {
        this.form = form;
    }

    // Checks if grecaptcha is loaded, loads if not
    async recaptchaLoaded() {
        if (typeof grecaptcha === 'undefined') {
            const { default: recaptcha } = await import('../../thirdparty/recaptcha/recaptchascript.js');
            // attempts to add the recaptcha script to the page again
            if (recaptcha && typeof recaptcha.init === 'function') {
                await recaptcha.init(); // attempts to add the recaptcha script to the page again
            } else {
                console.error('Error reinitializing reCAPTCHA script');
            }
        }
        return typeof grecaptcha !== 'undefined';
    }

    // Ensure reCAPTCHA is loaded
    async ready(callBack){
        if (await this.recaptchaLoaded()) {
            await grecaptcha.ready(async () => {
                if(typeof callBack === "function") await callBack();
            });
        } else {
            const recaptchaBlurb = document.querySelector(".recaptchaText");
            if(recaptchaBlurb) StatusMessages.showError(recaptchaBlurb, MESSAGES.error);
            console.error('reCAPTCHA not loaded');
        }
    }

    // Fetches the reCAPTCHA token and sets it in an object to pass back through the form success function
    async fetchFormRecaptcha(){
        const formRecaptcha = {
            key: this.form.querySelector('.recaptchaSiteKey')?.value ?? null,
            name: this.form.querySelector('.recaptchaActionName')?.value ?? null,
            token: null
        };
        try {
            formRecaptcha.token = await this.getToken(formRecaptcha.key, formRecaptcha.name);
            if(formRecaptcha.token){
                console.log(formRecaptcha.token);
                const tokenField = this.form.querySelector('.recaptchaToken');
                if(tokenField) tokenField.value = formRecaptcha.token;
            }
            return formRecaptcha;
        } catch (error) {
            console.error('Error submitting form:', error);
            return null;
        }
    }

    // Gets the reCAPTCHA token for the current action
    async getToken(siteKey, actionName) {
        if (!siteKey || siteKey == "") {
            siteKey = this.recaptchaKey;
            if (!siteKey || siteKey == "") {
                console.error('Recaptcha key not found');
                return null;
            }
        }
        if (!actionName || actionName == "") {
            actionName = this.recaptchaName;
            if (!actionName || actionName == "") {
                console.error('Recaptcha action name not found');
                return null;
            }
        }
        return grecaptcha.execute(siteKey, { action: actionName });
    }
}